import styled from 'styled-components';

export const SendButton = styled.button`
  background-color: #0084ff;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  margin-left: 10px;
  cursor: pointer;
  font-size: 18px;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const ConversationContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;
  gap: 10px;
  margin-bottom: 15px;
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  gap: 10px;
`;

export const ActionButton = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${(props) => (props.variant === 'primary' ? '#007bff' : '#f0f0f0')};
  color: ${(props) => (props.variant === 'primary' ? 'white' : '#333')};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
`;

export const QuestionInput = styled.input`
  flex-grow: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
`;

export const SendButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ConversationItem = styled.div`
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: grid;
`;

export const ConversationQuestion = styled.div`
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  &:before {
    content: 'Q: ';
    color: #007bff;
    margin-right: 6px;
  }
`;

export const ConversationAnswer = styled.div`
  color: #666;
  display: flex;
  flex-direction: column;
  /* align-items: center; */

  &:before {
    content: 'A: ';
    color: #28a745;
    margin-right: 6px;
    align-self: baseline;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 15px;
`;

export const InputLabel = styled.label`
  display: flex;
  align-items: center;
  color: #555;
  font-size: 15px;
  gap: 8px;
`;
